export const GraphicAspectRatio = {
	AR_16_9: '16:9',
	AR_9_16: '9:16',
	AR_4_5:  '4:5',
};
